/* Produktseite: „Passender Kissenbezug hinzufügen" – 7 O'CLOCK
   Angelegt: 2026-09-30, Logik vereinfacht 01.10.2026. Markup: snippets/7oc-product-pillow.liquid.
   Größe wählen → „Hinzufügen" legt den Kissenbezug sofort (1 Stück) in den Warenkorb und öffnet den Mini-Cart.
   Unabhängig davon, ob die Bettwäsche schon im Warenkorb liegt oder erst danach dazukommt.
   Nach dem Hinzufügen zeigt der Button „Im Warenkorb ✓"; eine andere Größe wählen setzt ihn zurück.
   05.10.2026: Button-Zustand folgt dem echten Warenkorb – wird der Kissenbezug im Mini-Cart entfernt
   (oder liegt er beim Seitenaufruf schon drin), passt sich der Button an (Abgleich über /cart.js). */
(function () {
  'use strict';

  var box = document.querySelector('[data-oc-pillow]');
  if (!box) return;

  var sizes = Array.prototype.slice.call(box.querySelectorAll('.oc-pillow_size'));
  var addBtn = box.querySelector('[data-oc-pillow-add]');
  var priceEl = box.querySelector('[data-oc-pillow-price]');
  var img = box.querySelector('.oc-pillow_image img');
  var current = null;
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartIds = null; /* Varianten-IDs, die laut /cart.js im Warenkorb liegen */

  function setAdded(on) {
    box.classList.toggle('is-selected', on);
    addBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function currentId() {
    return current ? parseInt(current.getAttribute('data-variant'), 10) : 0;
  }

  /* Button-Zustand aus dem bekannten Warenkorb-Stand ableiten */
  function applyCartState() {
    if (!cartIds) return;
    setAdded(cartIds.indexOf(currentId()) !== -1);
  }

  var syncTimer = null;
  function syncWithCart(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          cartIds = cart.items.map(function (it) { return it.variant_id; });
          applyCartState();
        })
        .catch(function () {});
    }, delay || 0);
  }

  function select(btn) {
    if (!btn || btn.disabled) return;
    sizes.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    current = btn;
    if (priceEl) priceEl.textContent = btn.getAttribute('data-price') || '';
    if (img && btn.getAttribute('data-image')) img.src = btn.getAttribute('data-image');
    if (cartIds) applyCartState(); else setAdded(false);
  }

  var first = box.getAttribute('data-first');
  select(sizes.filter(function (b) { return b.getAttribute('data-handle') === first; })[0] || sizes.filter(function (b) { return !b.disabled; })[0]);

  sizes.forEach(function (b) {
    b.addEventListener('click', function () { select(b); });
  });

  function addPillow() {
    if (!current || busy || box.classList.contains('is-selected')) return;
    var id = currentId();
    if (!id) return;
    busy = true;
    addBtn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      setAdded(true);
      if (cartIds && cartIds.indexOf(id) === -1) cartIds.push(id);
      /* Theme-Events: Mini-Cart neu laden und öffnen (wie beim normalen „In den Warenkorb legen") */
      try {
        window.dispatchEvent(new CustomEvent('cartupdated', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('toggleminicart', { bubbles: true }));
      } catch (e) {}
    }).catch(function () {
      setAdded(false);
    }).then(function () {
      busy = false;
      addBtn.disabled = false;
    });
  }

  addBtn.addEventListener('click', addPillow);

  /* ---- Abgleich mit dem Warenkorb ---- */
  syncWithCart(0);

  /* Theme-Event nach Änderungen im Warenkorb */
  window.addEventListener('cartupdated', function () { syncWithCart(600); });
  document.addEventListener('cartupdated', function () { syncWithCart(600); });

  /* Mini-Cart-Positionen beobachten (Entfernen/Menge ändern löst kein Theme-Event aus, das wir sicher kennen) */
  var itemCount = -1;
  var obs = new MutationObserver(function () {
    var n = document.querySelectorAll('.mini-cart_item').length;
    if (n !== itemCount) {
      itemCount = n;
      syncWithCart(500);
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  /* Zurück-Navigation (bfcache) und Tab-Wechsel: Stand neu holen */
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncWithCart(0); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncWithCart(0); });
})();
